// extracted by mini-css-extract-plugin
export default {"tooltip":"Hn-z","sharingV2":"In-z","sharingIconsV2":"Jn-z","links":"Kn-z","link":"Ln-z","facebookV2":"Mn-z","twitterV2":"Nn-z","pinterestV2":"On-z"};